import Moment from 'moment';
import MomentTz from 'moment-timezone';
import React from 'react';
import { Button, SelectionControl, SelectionControlGroup, Tooltipped  } from 'react-md';
import { browserHistory } from 'react-router';
import '../css/mediaCss.css';
import styles from '../css/styles.css.js';
import blackArrowIcon from '../images/png/blackArrow.png';
import copyIcon from '../images/png/copy.png';
import crossIcon from '../images/png/crossIcon.png';
import downArrowIcon from '../images/png/down_arrow.png';
import editIcon from '../images/png/edit.png';
import moveIcon from '../images/png/move.png';
import successIcon from '../images/png/success.png';
import upArrowIcon from '../images/png/up.png';
import whiteArrowIcon from '../images/png/whiteArrow.png';
import ViewIcon from '../images/svg/view_icon.svg';
import YellowDot from '../images/png/yellowdot.png';
import RedDot from '../images/png/reddot.png';
import GreenDot from '../images/png/greendot.png';
import SelectedViewIcon from '../images/svg/selected_view_icon.svg'
import ReactTooltip from 'react-tooltip';
import { AppSetting, AppProperties, IsPublicSite, getDateFormat } from '../common/function'
import { GetPrefixUniversity } from "../MainApp";
import CustomToggle from './CustomToggle'
import LoadingSpinner from '../component/LoadingSpinner';
import Toggle from "react-toggle";
import HelpText from '../lib/help-text';
import "./TableRow.css"
import { Checkbox, Tooltip } from '@mui/material';
import { Switch, FormControlLabel, Stack, Typography, Button as MaterialButton, ButtonGroup } from '@mui/material';
import { AppContext } from './context/AppContext.js';
import { FiTrash2 } from "react-icons/fi";
import { FiLink } from "react-icons/fi";


import moment from 'moment';
import { NotificationManager } from 'react-notifications';
import SFTooltip from '../pages/AssignmentMatrix/components/SFTooltip.jsx';
import { AiOutlineWarning } from "react-icons/ai";
import { BeatLoader } from 'react-spinners';

const tooltipDelay = 1000;

const normalizeValue = (val) => {
  return val ? val : "-";
}

const selectedStyle = {
    backgroundColor: "#bb0000",
    color: "#fff",
};

const unselectedStyle = {
    backgroundColor: "#f0f0f0",
    color: "#888",
    borderColor: "#ccc",
};

export default class TableRow extends React.Component {
  helpTextModel = new HelpText();
  AppSetting = AppSetting()
  appProperties = AppProperties()

  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      push: this.props.pushId,
      img: blackArrowIcon,
      userprofilerole : parseInt(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`), 10),
      instructorSubject :this.props.instructorSubject,
      _userAccessDetails: JSON.parse(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_userAccessDetails`)),
      username:window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_USER_NAME`)
    };
    
    this.onHover = this.onHover.bind(this);

  }
  onHover(e) {
    console.debug('Mouse Hovered');

    this.setState({
      img: whiteArrowIcon
    });
  }
  fetchTableDetails = e => {
    console.debug('fetchTableDetails', this.props.url);

    if (this.props.url !== undefined) {
      browserHistory.push(this.appProperties.baseFolder + this.props.url);
    }
    if (this.props.url === undefined && this.props.pushId === 'questions') {
      console.debug('fetchTableDetails e =', e);
      this.props.onEditClick();
    }
  };


  render() {
    let td1 = null;
    let td2 = null;
    let td3 = null;
    let td4 = null;
    let td5 = null;
    let td6 = null;
    let td7 = null;
    let td8 = null;

    let icon = RedDot;
    let altMessage = "Not Synced";
    if(this.props.pushId === 'subject' || this.props.pushId === 'topics' || this.props.pushId === 'category'){
      switch(this.props.data.sync_status){
        case 0:
          icon = YellowDot;
          altMessage = "Not Synced";
          break;
        case 1:
          icon = YellowDot;
          altMessage = "In-Progress";
          break;
        case 2:
          icon = GreenDot;
          altMessage = "Synced Successfully";
          break;
        case 3:
          icon = RedDot;
          altMessage = "Failed";
          break;
        default:
          icon = YellowDot;
          altMessage = "Not Synced";
          break;
      }
    }
    //let arrlist = null;
    let styleTdName = {cursor: 'pointer',color: '#576271'}
    if (this.props.countOfTCSQ !== undefined && this.props.countOfTCSQ !== null){
      styleTdName = {cursor: 'pointer',color: '#576271',textAlign:'left',paddingLeft:'25px'}
    }
    if (this.props.type === 'subcategory') {
      td1 = (
        <td style={styles.td} data-title="ID" onClick={this.fetchTableDetails}>
          {this.props.id}
        </td>
      );
      td2 = (
        <td
          style={{cursor: 'pointer',color: '#576271',textAlign:'left',paddingLeft:'25px'}}
          styldata-title="SubCategory"
          onClick={this.fetchTableDetails}
        >
          {this.props.name}
        </td>
      );
      td6 = (<td style={styles.tableCursorTd}>{normalizeValue(this.props.difficulty_level)}</td>) // accuracy/difficulty_level
      td7 = (<td style={styles.tableCursorTd}>{normalizeValue(this.props.avg_time)}</td>) // time/avg_time
      //td3 = <td data-title="Weight">{this.props.weight}</td>;
    } else if (this.props.type === 'quizCreation') {
      let imgClassName = 'fa fa-arrow-down';
      let imgRotateClassName = 'fa fa-arrow-down open arrowClass';

      var tdData1 = (
        <div
          style={{
            color: '#576271',
            float: 'left',
            paddingRight: '4px',
            paddingTop: '3px'
          }}
        >
          <input
            type="checkbox"
            style={{ display: 'none' }}
            onChange={() =>
              this.props.checkBoxCategoryOnChange(this.props.index)
            }
            value={this.props.id}
            checked={this.props.categorySelected[this.props.index].checked}
          />
          <img
            src={this.state.img}
            alt="catimage"
            className={
              this.props.categorySelected[this.props.index].showSubcategory
                ? imgClassName
                : imgRotateClassName
            }
            style={{ width: '10px' }}
            onClick={() => this.props.onEditClick(this.props.index)}
          />
        </div>
      );

      var tdData = <div data-title={this.props.title}>{this.props.name}</div>;

      var tdDifficulty = (
        <div>
          <div>
            {this.props.categorySelected[this.props.index].difficulty_level}
          </div>
        </div>
      );

      var tdAvg = (
        <div>{this.props.categorySelected[this.props.index].avg_time}</div>
      );

      //
      td2 = (
        <tr style={{ width: '100%' }}>
          <td style={{ fontsize: '14px' }}>{tdData1}</td>
          <td
            style={{ width: '160px' }}
            onClick={() => this.props.onSelectCategory(this.props.index)}
          >
            
            <button  className='ButtonLink aHrefClass' onClick={this.login}> {tdData}</button>
          </td>
          <td
            className="fixedWidth"
            style={{ width: '120px' }}
            onClick={() => this.props.onSelectCategory(this.props.index)}
          >
            {tdDifficulty}{' '}
          </td>
          <td
            className="fixedWidth"
            style={{ width: '100px' }}
            onClick={() => this.props.onSelectCategory(this.props.index)}
          >
            {tdAvg}{' '}
          </td>
          <td onClick={() => this.props.onSelectCategory(this.props.index)}>
            <div>
              {this.props.categorySelected[this.props.index]
                .rowSelectedCategory ? (
                <img alt="" src={successIcon} className="successIconPadding" />
              ) : (
                <div style={{ width: '50px' }} />
              )}
            </div>
          </td>
        </tr>
      );
    } else if (this.props.type === 'Quizes') {
      //let tempData = <td style={styles.td} data-title="ID" >{this.props.id}</td>
      //console.log("this.props.data.start_date ", this.props.data.start_date);
      var start_date = this.props.data.start_date ? MomentTz.tz(this.props.data.start_date+" "+this.props.data.start_time, "DD/MM/YYYY HH:mm", this.props.timezone).toDate() : "";
      var end_date = this.props.data.end_date ? MomentTz.tz(this.props.data.end_date+" "+this.props.data.end_time, "DD/MM/YYYY HH:mm", this.props.timezone).toDate()  : "";    

      td1 = <td>{this.props.id}</td>;

      td2 = (
        <td
          style={styles.tableCursorTd}
          data-title={this.props.title}
          onClick={
            this.props.pushId === 'questions'
              ? this.props.onEditClick
              : this.fetchTableDetails
          }
        >
          {this.props.name}
        </td>
      );
      td3 = <td>{start_date ? Moment(start_date).format('MM/DD/YYYY HH:mm') : "N/A"}</td>;
      td4 = <td>{end_date ? Moment(end_date).format('MM/DD/YYYY HH:mm') : "N/A"}</td>;
      
      if (!this.props.isLtiCourse) {
        td5 = <td>
            <span style={{margin:'10px 2px'}}>
              <SelectionControl
                id={"switch-status" + this.props.rowIndex}
                className={
                  (this.props.status == 1 ? "course-status-toggle-on " : "course-status-toggle-off ") +
                  (this.props.disableActionButtons ? "selection-control-disabled" : "")
                }
                type="switch"
                name="Status"
                label={null}
                checked={this.props.status === 1}
                onClick={this.props.handleUpdateAssignmentStatus}
                disabled={this.props.disableActionButtons}
                style={{ float: 'none', display: 'inline-block' }}
                data-tip
                data-for={this.props.status === 1 ? 'course-status-off' : 'course-status-on'}
              />
              <ReactTooltip id={'course-status-off'} type='light' className='tool-tip'>
                <span>Click to Unpublish</span>
              </ReactTooltip>
              <ReactTooltip id={'course-status-on'} type='light' className='tool-tip'>
                <span>Click to Publish</span>
              </ReactTooltip>
          </span>
        </td>
      }
    }  else if (this.props.pushId === 'explanations') {
     // console.debug(this.props.text)
      console.debug(this.props.name)
      td1 = (
        <td style={styles.td} data-title="ID">
          {this.props.id}
        </td>
      );
      td2 = (
        <td
          style={styles.tableCursorTd}
          data-title={this.props.name}
          onClick={
            this.props.pushId === 'explanations'
              ? this.props.onEditClick
              : this.fetchTableDetails
          }
        >
          {this.props.name}
        </td>
      );
    
    }else if (this.props.pushId === 'category') {
      td1 = (
        <td style={{color: '#576271'}} data-title="ID">
          {this.props.id}
        </td>
      );
      td2 = (
        <td
          style={styleTdName}
          data-title={this.props.title}
          onClick={
            this.props.pushId === 'questions'
              ? this.props.onEditClick
              : this.fetchTableDetails
          }
        >
          {this.props.name}
        </td>
      );
      td3 = ( 
        <td
          style={styles.tableCursorTd}
          data-title={this.props.title}
        >
          {this.props.custom_label}
        </td>);
      td6 = (<td style={styles.tableCursorTd}>{normalizeValue(this.props.difficulty_level)}</td>) // accuracy/difficulty_level
      td7 = (<td style={styles.tableCursorTd}>{normalizeValue(this.props.avg_time)}</td>) // time/avg_time

    } else if (this.props.pushId === 'helpMenuList') {
      
      td1 = (
        <td style={styles.td} data-title="ID">
          {this.props.id}
        </td>
      );
      td2 = (
        <td
          style={styles.tableCursorTd}
          data-title={this.props.name}
          onClick={ this.props.onEditClick}
        >
          {this.props.name}
        </td>
      );
    
    }  else if (this.props.pushId === 'questions') {
      td1 = (
        <>
          <td style={styles.td} data-title="checkbox">
            <Checkbox 
              id={`select-question-checkbox-${this.props.data.question_id}`}
              size='small'
              style={{margin: 0, padding: 0}}
              checked={!!this.props.data.selected}
              onChange={(_, checked) => {
                if (this.props.onSelectQuestion) {
                  this.props.onSelectQuestion(checked);
                }
              }}
            />
          </td>
          <td style={styles.td} data-title="ID">
            {this.props.id}
          </td>
        </>
      );
      td2 = (
        <td
          style={styles.tableCursorTd}
          data-title={this.props.title}
          onClick={
            this.props.pushId === 'questions'
              ? this.props.onEditClick
              : this.fetchTableDetails
          }
          onMouseOver={this.props.onMoveOver}
        >
          {this.props.name}
        </td>
      );

      const buildLinkUrl = (key) => {
        const parts = key.split('_');
        if (parts.length < 5) return null;
        const [subjId, topId, catId, subcatId, questId] = parts;
        return this.appProperties.baseFolder +
          'SubCategoryDetails?subject_id=' + subjId +
          '&topic_id=' + topId +
          '&category_id=' + catId +
          '&subcategory_id=' + subcatId +
          '&question_id=' + questId +
          '&archive_mode=false&archive_id=1';
      };

      const renderLinkKey = (key) => {
        const url = buildLinkUrl(key);
        if (!url) return key;
        return (
          <span
            style={{ color: '#3d5e9c', cursor: 'pointer', textDecoration: 'underline' }}
            onClick={(e) => { e.stopPropagation(); browserHistory.push(url); }}
          >
            {key}
          </span>
        );
      };

      // linked question urls can come back with another university's domain (e.g. osu.cpanel...),
      // so point them at the current host instead
      const toCurrentHostUrl = (quesURL) => {
        try {
          const url = new URL(quesURL);
          if (url.hostname !== window.location.hostname) {
            url.protocol = window.location.protocol;
            url.host = window.location.host;
          }
          return url.toString();
        } catch (e) {
          return quesURL;
        }
      };

      td4 = (
        <td style={styles.td} data-title="Parent Link">
          {this.props.data.parent_linked_question_key
            ? 
              <Tooltip title="Open this question in a new tab" arrow placement='top'>
                  <a
                      className="linked-question-chip"
                      href={toCurrentHostUrl(this.props.data.parent_linked_question_url)}
                      target="_blank"
                      rel="noopener noreferrer"
                  >
                      {this.props.data.parent_linked_question_key}
                  </a>
              </Tooltip>
            : "-"}
        </td>
      );
      let childKeysArr = this.props.data?.child_linked_question_keys?.split(",")
      td5 = (
        <td style={styles.td} data-title="Child Links">
          {this.props.data.child_linked_question_urls && this.props.data.child_linked_question_urls.length
            ? this.props.data.child_linked_question_urls.map((quesURL, index) => {
              let key = "";
              if (childKeysArr && childKeysArr[index]) {
                key = childKeysArr[index];
              }
                return (
                  <Tooltip title="Open this question in a new tab" arrow placement='top'>
                    <a
                        className="linked-question-chip"
                        href={toCurrentHostUrl(quesURL)}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {key}
                    </a>
                  </Tooltip>
                )
            })
            : "-"}
        </td>
      );
      td6 = (
        <td style={styles.td} data-title="Accuracy">
          {normalizeValue(this.props.data.difficulty_level)}
        </td>
      );
      td7 = (
        <td style={styles.td} data-title="Time">
          {normalizeValue(this.props.data.avg_time)}
        </td>
      );
      if(this.state.instructorSubject || this.state.instructorSubject === undefined){
      td3 = ( 
      <td
        style={{ width: '100px', paddingLeft: '10px' }}
        
      >
        <Button icon onClick={this.props.questionOrderOnMoveUp}>
          <img
            style={{ width: '20px', float: 'left' }}
            src={upArrowIcon}
            alt="UP"
          />
        </Button>
        <Button icon onClick={this.props.questionOrderOnMoveDown}>
          <img
            style={{ width: '20px', float: 'left' }}
            src={downArrowIcon}
            
            alt="Down"
          />
        </Button>
      </td>);
      }else{
        td3 = ( 
          <td
            style={{ width: '100px', paddingLeft: '10px' }}
          >
          </td>);
      }

    } else if (this.props.pushId === 'sections') {
      td1 = (
        <td style={styles.td} data-title="ID">
          {this.props.id}
        </td>
      );
      td2 = (
        <td
          style={styles.tableCursorTd}        
          data-title={this.props.title}
          onClick={ this.fetchTableDetails}
        >
          {this.props.name}
        </td> 
      );
      const date = this.props.data.created_at;
      const m = moment(date);
      let createdAt;
      if (!m.isValid() || m.year() <= 1) {
        createdAt =  "N/A";
      } else {
        createdAt = getDateFormat(this.props.data.created_at);
      }
      td3 = (
        <td
          style={styles.tableCursorTd}        
          data-title={this.props.title}
          onClick={ this.fetchTableDetails}
        >
          {createdAt}
        </td> 
      );
      td4 = (
        <td
          style={styles.tableCursorTd}        
          data-title={this.props.title}
          onClick={ this.fetchTableDetails}
        >
          {this.props.data.created_by ? this.props.data.created_by : "N/A"}
        </td> 
      );
      td5 = (
        <td>
        <SelectionControl
        id={"enable-current-section"+ this.props.id}
        type="switch"
        className={this.props.disableActionButtons ? "selection-control-disabled" : ""}
        name="enableSubSection"
        label={null}
        style={{float: 'none', display: 'inline-block'}}
        checked={this.props.enable_subsection}
        onClick={this.props.onEnableSubsection}
        disabled={this.props.disableActionButtons}
        />
        </td>
      );
      td6 = (
        <td>
        <div style={{display:"flex",alignContent:"center",justifyContent:"center"}}>
                  <div className='textfield-container'>
                      {/* <div style={{ fontWeight: 600, width: "100%", paddingRight: "4px" }}>Choose Subsections</div> */}
                       <SelectionControl
                          id={"enable-practice-section"+ this.props.id}
                          type="switch"
                          name="enablePractice"
                          label={null}
                          className={this.props.disableActionButtons ? "selection-control-disabled" : ""}
                          style={{float: 'none', display: 'inline-block'}}
                          checked={this.props.EnablePracticeAndPerformance === 2}
                          disabled={this.props.disableActionButtons}
                          onClick={() => {
                            if (this.props.disableActionButtons) return;
                            let valInt = this.props.EnablePracticeAndPerformance === 2 ? 0 : 2;
                            this.props.onEnableDashboard(valInt);
                            // setSelectedSectionIDArr([]);
                            // setSelectedSectionAndSubsectionList([]);
                            // setEnableSubSection(!enableSubSection);
                          }}
                        />
                  </div>
                  {/* <SelectionControlGroup
                      id={"enable-current-sectionpractice"+ this.props.id}
                      name={"enable-current-sectionpractice"+ this.props.id}
                      type="radio"
                      value={this.props.EnablePracticeAndPerformance}
                      onChange={(val) => {
                        let valInt = parseInt(val);
                        this.props.onEnableDashboard(valInt);
                      }}
                      controls={[{
                        label: (
                          <div>OFF
                            <Button className='nocqcStyle' icon data-tip data-for='practice-off'>help</Button>
                            <ReactTooltip id='practice-off' type='light' className='tool-tip'>
                              <span>{this.helpTextModel.getHelpTextForKey('Practice OFF')}</span>
                            </ReactTooltip>
                          </div>

                        ),
                        value: 0,
                      }, {
                        label: (
                          <div>Practice
                            <Button className='nocqcStyle' icon data-tip data-for='practice'>help</Button>
                            <ReactTooltip id='practice' type='light' className='tool-tip'>
                              <span>{this.helpTextModel.getHelpTextForKey('Practice')}</span>
                            </ReactTooltip>
                          </div>
                        ),
                        value: 1,
                      }, {
                        label:  (
                          <div>Practice & Analytics
                            <Button className='nocqcStyle' icon data-tip data-for='practice-analytics'>help</Button>
                            <ReactTooltip id='practice-analytics' type='light' className='tool-tip'>
                              <span>{this.helpTextModel.getHelpTextForKey('Practice & Analytics')}</span>
                            </ReactTooltip>
                          </div>
                        ),
                        value: 2,
                      }]}
                /> */}
              {/* <div style={{display:"flex",marginRight:"10px"}}>
                        <input
                            type="radio"
                            name={"enable-current-sectionpractice"+ this.props.id}
                            checked={this.props.EnablePracticeAndPerformance === 0}
                            onChange={ (value) =>  this.props.onEnableDashboard(0)}
                      />
                      OFF
                      <Button className='nocqcStyle' icon data-tip data-for='Practice OFF'>help</Button>
                      <ReactTooltip id='Practice OFF' type='light' className='tool-tip'>
                        <span>{this.helpTextModel.getHelpTextForKey('Practice OFF')}</span>
                      </ReactTooltip>
              </div>
              <div style={{display:"flex",marginRight:"10px"}}>
                        <input
                            type="radio"
                            name={"enable-current-sectionpractice"+ this.props.id}
                            value="1"
                            checked={this.props.EnablePracticeAndPerformance === 1 }
                            onChange={ (value) =>  this.props.onEnableDashboard(1)}
                      />
                      Practice
                      <Button className='nocqcStyle' icon data-tip data-for='Practice'>help</Button>
                      <ReactTooltip id='Practice' type='light' className='tool-tip'>
                        <span>{this.helpTextModel.getHelpTextForKey('Practice')}</span>
                      </ReactTooltip>
              </div>
              <div style={{display:"flex"}}>
                        <input
                           name={"enable-current-sectionpractice"+ this.props.id}
                            type="radio"
                            checked={ this.props.EnablePracticeAndPerformance === 2}
                            onChange={(event) =>  this.props.onEnableDashboard(2)}
                      />
                      Practice & Analytics
                      <Button className='nocqcStyle' icon data-tip data-for='Practice & Analytics'>help</Button>
                      <ReactTooltip id='Practice & Analytics' type='light' className='tool-tip'>
                        <span>{this.helpTextModel.getHelpTextForKey('Practice & Analytics')}</span>
                      </ReactTooltip>
              </div> */}
        </div>
                       
        </td>
      );
      if (this.props.showHomepageColumn) {
        td7 = (
          <td>
          <SelectionControl
          id={"show-in-home-page"+ this.props.id}
          type="switch"
          name="showInHomePage"
          label={null}
          style={{float: 'none', display: 'inline-block'}}
          checked={this.props.data.show_in_homepage}
          onClick={this.props.onChangeShowInHomePage}
          />
          </td>
        )
      }
    }else if (this.props.type === 'StudentDetailsForQuiz') {

      td1 = (
        <td style={styles.td} data-title="ID">
          {this.props.id}
        </td>
      );
      td2 = (
        <td
          style={styles.tableCursorTd}        
         
        >
          {this.props.data.student_start_time}
        </td>
      );
      td3 = (
        <td
          style={styles.tableCursorTd} >
          {this.props.data.student_end_time}
        </td>
      );
     
    } else if (this.props.type === 'instructorsList') {

      td1 = (
        <td style={styles.td} data-title="ID">
          {this.props.id}
        </td>
      );
      td2 = (
        <td
          style={styles.tableCursorTd}        
         data-title={this.props.title}
          onClick={ this.fetchTableDetails}
        >
          {this.props.name}
        </td> 
      );
      td3 = (
        <td
          style={styles.tableCursorTd}        
          data-title={this.props.title}
           onClick={ this.fetchTableDetails} >
          {this.props.data.instructor_first_name}
        </td>
      );
      td4 = (
        <td
          style={styles.tableCursorTd}         
          data-title={this.props.title}
           onClick={ this.fetchTableDetails}>
          {this.props.data.instructor_last_name}
        </td>
      );
     
    }
    else if (this.props.type === 'AdminsList') {
      td1 = (
        <td style={styles.td} data-title="ID">
          {this.props.id}
        </td>
      );
      td2 = (
        <td
          style={styles.tableCursorTd}        
         data-title={this.props.title}
          onClick={ this.fetchTableDetails}
        >
          {this.props.name}
        </td> 
      );
      td3 = (
        <td
          style={styles.tableCursorTd}        
          data-title={this.props.title}
           onClick={ this.fetchTableDetails} >
          {this.props.data.admin_first_name}
        </td>
      );
      td4 = (
        <td
          style={styles.tableCursorTd}         
          data-title={this.props.title}
           onClick={ this.fetchTableDetails}>
          {this.props.data.admin_last_name}
        </td>
      );
    }else if(this.props.pushId === 'subject' || this.props.pushId === 'topics'){
      td1 = (
        <td style={{color: '#576271'}} data-title="ID">
          {this.props.id}
        </td>
      );
      td2 = (
        <td
          style={styleTdName}
          data-title={this.props.title}
          onClick={
            this.props.pushId === 'questions'
              ? this.props.onEditClick
              : this.fetchTableDetails
          }
        >
         {this.props.name}
        </td>
      );

    } else if (this.props.pushId === "course") {
      console.debug("this.props.status === 1", this.props.status === 1)
      td1 = <td>
        {this.props.id}
      </td>
      td2 = <td style={{cursor:'pointer'}} onClick={this.fetchTableDetails}>
        <div style={{display:"flex", justifyContent:'center', gap:'6px'}}>
            <div>{this.props.name}</div>
            <div>
              {this.props?.data?.sections_count === 0 ? 
                  <SFTooltip text={this.helpTextModel.getHelpTextForKey("No Sections")} placement="top">
                    <span>
                      <AiOutlineWarning style={{ color: "orange" }} fontSize={18} title="No sections added" />
                    </span>
                  </SFTooltip>
              : null}
            </div>
          </div>
      </td>
      if (this.context?.isPublicSite) {
        td3 = <td>
          <SFTooltip text="Copy code to clipboard." placement="right">
            <span>
              <Button flat 
                style={{ textTransform: "none" }}
              onClick={() => {
                navigator.clipboard.writeText(this.props.data?.code)
                NotificationManager.success("Code copied to your clipboard.", "")
              }}>
                <span>
                  {this.props.data && this.props.data.code ? this.props.data.code : "-" }
                </span>
              </Button>
            </span>
          </SFTooltip>
        </td>
      } else {
        td3 = null;
      }
      
      td4 = <td>
        {this.props.created_at !== "0001-01-01T00:00:00Z" ? MomentTz.tz(this.props.created_at, this.props.timezone).format('MM/DD/YYYY HH:mm z') : "N/A"}
      </td>
      td5 = <td>
        {this.props.created_by ? this.props.created_by : "N/A"}
      </td>
      if (this.context?.isPublicSite) {
        td6 = null;
      } else {
      td6 = <td>
        <React.Fragment>
            <SelectionControl 
            id={"switch-currentSubject" + this.props.rowIndex}
            type="switch"
            className={this.props.disableActionButtons ? "selection-control-disabled" : ""}
            name="Lticourses"
            label={null}
            disabled={this.props.disableActionButtons}
            checked={this.props.isLtiCourse}
            onClick={this.props.onLTICourseChange}
            style={{float: 'none', display: 'inline-block'}}
            data-tip data-for='lti-course'
            />
            {/* <ReactTooltip id={'lti-course'} type='light' className='tool-tip'>
              <span>{'LTI Course'}</span>
            </ReactTooltip> */}
          </React.Fragment>
      </td>
      }
      td7 = <td>
        <React.Fragment>
          {!this.props.isLtiCourse ?
            <div>
              <SelectionControl
                id={"switch-status" + this.props.rowIndex}
                className={
                    (this.props.status == 1 ? "course-status-toggle-on " : "course-status-toggle-off ") +
                    (this.props.disableActionButtons ? "selection-control-disabled" : "")
                }
                type="switch"
                name="Status"
                label={null}
                checked={this.props.status === 1}
                onClick={this.props.handleUpdateCourseStatus}
                style={{ float: 'none', display: 'inline-block' }}
                data-tip
                data-for={this.props.status === 1 ? 'course-status-off' : 'course-status-on'}
                disabled={this.props.disableActionButtons}
              />
              <ReactTooltip id={'course-status-off'} type='light' className='tool-tip'>
                <span>Click to Unpublish</span>
              </ReactTooltip>
              <ReactTooltip id={'course-status-on'} type='light' className='tool-tip'>
                <span>Click to Publish</span>
              </ReactTooltip>
            </div>
            : null
          }
        </React.Fragment>
      </td>
      if (this.context.isPublicSite) {
        td8 = <td>
            <ButtonGroup
              disableElevation
              disabled={this.props.disableActionButtons}
              size='small'
              aria-label="visibility-btn-grp"
              // onClick={this.props.handleCourseVisibility}
            >
              <SFTooltip text={this.helpTextModel.getHelpTextForKey('Public Course')}>
                <MaterialButton style={this.props.data.is_public === 1 ? selectedStyle : unselectedStyle} 
                  onClick={() => this.props.handleCourseVisibility(1)}
                >Public</MaterialButton>
              </SFTooltip>
              <SFTooltip text={this.helpTextModel.getHelpTextForKey('Private Course')}>
                <MaterialButton style={this.props.data.is_public === 1 ? unselectedStyle : selectedStyle} 
                  onClick={() => this.props.handleCourseVisibility(0)}
                >Private</MaterialButton>
              </SFTooltip>
            </ButtonGroup>
        </td>
      }
    }
   else {
      td1 = (
        <td style={{color: '#576271'}} data-title="ID">
          {this.props.id}
        </td>
      );
      td2 = (
        <td
          style={styleTdName}
          data-title={this.props.title}
          onClick={
            this.props.pushId === 'questions'
              ? this.props.onEditClick
              : this.fetchTableDetails
          }
        >
          {this.props.name}
        </td>
      );
    }

    // console.debug("Table data: ",this.props.data.subCategory_id,this.props.data.subCategory_name)
    // }else if(this.state.push == "questions"){

    //     td1= <td style={styles.td} data-title="ID" >{this.props.data.question_id}</td>
    //     td2= <td style={styles.td} data-title="Questions" >{this.props.data.question_name}</td>
    //}
    let actionButton;
    let synButton ;
    //superadmin
      if ( this.state?.userprofilerole === 2 && this.props?.syncSwitch && (this.state.username == "jith" || this.state.username == "heckler.6" || this.state.username == "rangaraj.5")) {

         synButton = (
          <div style={{marginTop:"8px"}}>
           {this.props.pushId === 'subject' || this.props.pushId === 'topics' || this.props.pushId === 'category' ? (
            
             <React.Fragment>
               {
                 this.props?.synloading ?
    
                 <LoadingSpinner loading={this.props?.synloading} /> 
                 :
                   <CustomToggle 
                   Enabled={this.props.syncEnabled}
                   tristate={(this.props?.someSyncEnabled) ? this.props?.someSyncEnabled : false }
                   onEnableChecked={this.props.onEnableSync}
                   onDisableChecked={this.props.onDisableSync}
                   onHandleMiddleredirect={this.props.onHandleRedirect}
                   onNavigatePage={this.fetchTableDetails}
                   syncStatus={this.props.data.sync_status}
                   sourceRedirect={!this.state.instructorSubject}
                   type="switch"
                   name="currentSubject"
                   id={"switch-currentSubject" + this.props.rowIndex}
                   />
               }
               <ReactTooltip id={'test-mode'} type='light' className='tool-tip'>
                 <span>{'Auto Sync'}</span>
               </ReactTooltip>
             </React.Fragment>
               ) : (
                 ''
               )}
          </div>
         )
        
      }
    if(this.state.instructorSubject || this.state.instructorSubject === undefined ){
 
     actionButton = (
      <div>

      {this.props.pushId === 'questions'  ? 
           this.props.questionIndex === this.props.selectedRowIndex ? (
              <Button icon tooltipDelay={tooltipDelay} tooltipLabel="view" style={{width:'50px'}} onClick={() => this.props.onViewClick( this.props.questionIndex,true)}>
              <img src={SelectedViewIcon} alt="view" />
              </Button>
              
              ) : (
          <Button icon tooltipDelay={tooltipDelay} tooltipLabel="view" style={{width:'50px'}} onClick={this.props.onViewClick}>
              <img src={ViewIcon} alt="view" />
              </Button>
              ) :(
                ''
        )}

      {this.props.pushId === 'explanations'  ? 
           this.props.explanationIndex === this.props.selectedRowIndex ? (
              <Button icon tooltipDelay={tooltipDelay} tooltipLabel="view" style={{width:'50px'}} onClick={() => this.props.onViewClick( this.props.explanationIndex,true)}>
              <img src={SelectedViewIcon} alt="view" />
              </Button>
              
              ) : (
          <Button icon tooltipDelay={tooltipDelay} tooltipLabel="view" style={{width:'50px'}} onClick={this.props.onViewClick}>
              <img src={ViewIcon} alt="view" />
              </Button>
              ) :(
                ''
        )}

          {/* {
                  this.props.pushId ===  'course' ? 
                    <React.Fragment>
                    <SelectionControl 
                    id={"switch-currentSubject" + this.props.rowIndex}
                    type="switch"
                    name="Lticourses"
                    label={null}
                    checked={this.props.isLtiCourse}
                    onClick={this.props.onLTICourseChange}
                    style={{float: 'none', display: 'inline-block'}}
                    data-tip data-for='lti-course'
                    />
                    <ReactTooltip id={'lti-course'} type='light' className='tool-tip'>
                      <span>{'LTI Course'}</span>
                    </ReactTooltip>
                  </React.Fragment>
                  
                  : ""

                } */}

              {
              (!this.appProperties.enableLTI || 
                !(this.props.pushId === 'subject' || this.props.pushId === 'topics' 
                || this.props.pushId === 'category' || this.props.pushId === 'subcategory'
                || this.props.pushId === 'questions' ||this.props.pushId === 'explanations'
                )
                ) ? (this.appProperties.currentUserData.role === 2 || this.props.created_by === this.appProperties.currentUserData.USER_NAME) && // LTI QB edit Disable
              <Button icon tooltipDelay={tooltipDelay} tooltipLabel="Edit" onClick={this.props.onEditClick}
                disabled={this.props.disableActionButtons}>
                 <img src={editIcon} style={{
                  opacity: this.props.disableActionButtons ?  0.5 : 1,
                 }} alt="Edit"  />
              </Button> : ""}
       
        {this.props.pushId === 'questions' && (!this.appProperties.enableLTI)   ? (
          <div style={{ display: 'inline' }}>
            <Button icon tooltipDelay={tooltipDelay} tooltipLabel="Duplicate" onClick={this.props.onCopyClick}>
              <img src={copyIcon} alt="Copy"  />
            </Button>
            
          </div>
        ) : (
          ''
        )}

        {window.location.hostname.includes("colorado") || window.location.hostname.includes("localhost") ? 
        (this.props.pushId === 'questions' && (!this.appProperties.enableLTI) && this.props.onDuplicateQuestionAndLinkClick  ? (
          <div style={{ display: 'inline' }}>
            <Button icon tooltipDelay={tooltipDelay} tooltipLabel="Link question to different subcategories" onClick={this.props.onDuplicateQuestionAndLinkClick}>
              <span>
                <FiLink color='#bb0000' />
              </span>
            </Button>
          </div>
        ) : null)
        : null}

        {/* temporarily removed move option from questions */}
        {/* {this.props.pushId === 'questions' && (!this.appProperties.enableLTI)  ? (
              <Button icon tooltipDelay={tooltipDelay} tooltipLabel="Move" onClick={this.props.onMoveClick}>
              <img src={moveIcon} alt="Copy" />
              </Button>
              
              ) : (
                ''
        )} */}

        {/* temporarily removed move option from category */}
        {/* {this.props.pushId === 'category'  && (!this.appProperties.enableLTI) ? (
              <Button icon tooltipDelay={tooltipDelay} tooltipLabel="Move" onClick={this.props.onMoveCategoryClick}>
              <img src={moveIcon} alt="Move" />
              </Button>
              
              ) : (
                ''
        )} */}
        {this.props.pushId === 'category' && this.state.userprofilerole >= 2  && (!this.appProperties.enableLTI) ? (
          <Button icon tooltipDelay={tooltipDelay} tooltipLabel="Duplicate" onClick={this.props.onCopyClick}>
              <img src={copyIcon} alt="Copy" />
              </Button>
              
              ) : (
                ''
        )}
        {/* temporarily removed move option from subcategory */}
        {/* {this.props.pushId === 'subcategory'  && (!this.appProperties.enableLTI) ? (
             <Button icon tooltipDelay={tooltipDelay} tooltipLabel="Move" onClick={this.props.onMoveSubcategoryClick}>
              <img src={moveIcon} alt="Move" />
              </Button> 
              ) : (
                ''
        )} */}
        {this.props.pushId === 'subcategory' && this.state.userprofilerole >= 1  && (!this.appProperties.enableLTI) ? (
             <Button icon tooltipDelay={tooltipDelay} tooltipLabel="Duplicate" onClick={this.props.onCopyClick}>
              <img src={copyIcon} alt="Copy"  />
             </Button>
              ) : (
                ''
        )}
       {/*  {(
          (this.props.pushId === 'course' || this.props.pushId === 'sections' || this.props.pushId === 'Subsections')
          &&
          this.appProperties.currentUserData.role === 2 || this.props.created_by === this.appProperties.currentUserData.USER_NAME
        ) ? 
            <Button icon tooltipDelay={tooltipDelay} tooltipLabel="Delete" onClick={this.props.onDeleteClick}>
            <img
              src={crossIcon}
              alt="Delete"
            />
        </Button>
        : null } */}
      {
        (!this.appProperties.enableLTI || 
          !(this.props.pushId === 'subject' || this.props.pushId === 'topics' 
          || this.props.pushId === 'category' || this.props.pushId === 'subcategory'
          || this.props.pushId === 'questions' ||this.props.pushId === 'explanations'
          )
          ) ? // LTI QB edit Disable 
          (this.appProperties.currentUserData.role === 2 || this.props.created_by === this.appProperties.currentUserData.USER_NAME) &&
        <Button icon tooltipDelay={tooltipDelay} tooltipLabel="Delete" onClick={this.props.onDeleteClick}
          disabled={this.props.disableActionButtons}
        >
            <FiTrash2 fontSize={24} color={this.props.disableActionButtons ? "#bdbdbd" : "#bb0000"} />
        </Button> : ""

      }

       
      </div>
    );
    // hide the action columns for question that is been linked from parent question
    if (this.props.pushId === 'questions' && this.props.data.parent_linked_question_key) {
      actionButton = null;
    }
  }else{
     actionButton = (<div style={{height :"40px"}}>{this.props.pushId === 'questions'  ? 
     this.props.questionIndex === this.props.selectedRowIndex ? (
        <Button icon tooltipDelay={tooltipDelay} tooltipLabel="view" style={{width:'50px'}} onClick={() => this.props.onViewClick( this.props.questionIndex,true)}>
        <img src={SelectedViewIcon} alt="view" />
        </Button>
        
        ) : (
    <Button icon tooltipDelay={tooltipDelay} tooltipLabel="view" style={{width:'50px'}} onClick={this.props.onViewClick}>
        <img src={ViewIcon} alt="view" />
        </Button>
        ) :(
          ''
  )} {this.props.pushId === 'category' && !this.appProperties.enableLTI && (this.state.userprofilerole === 1 ||  this.state.userprofilerole === 2 )? (
      <Button icon tooltipDelay={tooltipDelay} tooltipLabel="Duplicate" onClick={this.props.onCopyClick}>
      <img src={copyIcon} alt="Copy" />
      </Button>
      
      ) : (
        ''
)}</div>)
  }
  
  if(this.props.show_archive_actions === true || this.props.show_archive_actions === 'true'){
     actionButton = (
        <div>
          <Button icon tooltipDelay={tooltipDelay} tooltipLabel="Restore From Archive" onClick={this.props.onArchiveRestoreClick}>
            <img src={moveIcon} alt="Restore"  />
          </Button>
          <Button icon tooltipDelay={tooltipDelay} tooltipLabel="Delete" onClick={this.props.onDeleteClick}>
            <img
              src={crossIcon}
              alt="Delete from Archive"
            />
          </Button>
        </div>
      );
  }
  let tdNoTopics = null
  let tdNoCat = null
  let tdNoSubCat = null
  let tdNoQue = null
  let tdNoExpl = null
  if (this.props.countLoading || (this.props.countOfTCSQ !== undefined && this.props.countOfTCSQ !== null)){
    if (this.props.pushId === 'subject'){
      tdNoTopics = (
          <td>{this.props.countLoading ? <BeatLoader color={'#bb0000'} size={6} loading={true} /> : this.props.countOfTCSQ?.number_of_topics}</td>
      );
      tdNoCat = (
        <td>{this.props.countLoading ? <BeatLoader color={'#bb0000'} size={6} loading={true} /> : this.props.countOfTCSQ?.number_of_categories}</td>
      )
      tdNoSubCat = (
        <td>{this.props.countLoading ? <BeatLoader color={'#bb0000'} size={6} loading={true} /> : this.props.countOfTCSQ?.number_of_subcategories}</td>
      )
      tdNoQue = (
        <td>{this.props.countLoading ? <BeatLoader color={'#bb0000'} size={6} loading={true} /> : this.props.countOfTCSQ?.number_of_questions}</td>
      )
      tdNoExpl = (
        <td>
          {this.props.countLoading ? <BeatLoader color={'#bb0000'} size={6} loading={true} /> : (

          <Tooltip
            arrow
            placement='right'
            title={
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: "center", fontSize: '14px' }}>
                <div>{this.props.explanationMap ? `Topic: ${this.props.explanationMap.total_topic_explanations}` : null}</div>
                <div>{this.props.explanationMap ? `Category: ${this.props.explanationMap.total_category_explanations}` : null}</div>
                <div>{this.props.explanationMap ? `Subcategory: ${this.props.explanationMap.total_subcategory_explanations}` : null}</div>
              </div>
            }>
              <div className='main-explanation-count'>
                {this.props.countOfTCSQ?.number_of_explanations}
              </div>
            {/* <div className='other-explanation-count'>
                <div>{this.props.explanationMap ? `T: ${this.props.explanationMap.total_topic_explanations}` : null}</div>
                <div>{this.props.explanationMap ? `C: ${this.props.explanationMap.total_category_explanations}` : null}</div>
                <div>{this.props.explanationMap ? `SC: ${this.props.explanationMap.total_subcategory_explanations}` : null}</div>
                </div> */}
          </Tooltip>
          )}
        </td>
      )
    } else if (this.props.pushId === 'topics'){
       tdNoCat = (
        <td>{this.props.countLoading ? <BeatLoader color={'#bb0000'} size={6} loading={true} /> : this.props.countOfTCSQ?.number_of_categories}</td>
      )
       tdNoSubCat = (
        <td>{this.props.countLoading ? <BeatLoader color={'#bb0000'} size={6} loading={true} /> : this.props.countOfTCSQ?.number_of_subcategories}</td>
      )
       tdNoQue = (
        <td>{this.props.countLoading ? <BeatLoader color={'#bb0000'} size={6} loading={true} /> : this.props.countOfTCSQ?.number_of_questions}</td>
      )
      tdNoExpl = (
        <td>
          {this.props.countLoading ? <BeatLoader color={'#bb0000'} size={6} loading={true} /> : (
            <Tooltip
              arrow
              placement='right'
              title={
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: "center", fontSize: '14px' }}>
                  <div>{this.props.explanationMap ? `Topic: ${this.props.explanationMap.total_topic_explanations}` : null}</div>
                  <div>{this.props.explanationMap ? `Category: ${this.props.explanationMap.total_category_explanations}` : null}</div>
                  <div>{this.props.explanationMap ? `Subcategory: ${this.props.explanationMap.total_subcategory_explanations}` : null}</div>
                </div>
              }>
                <div className='main-explanation-count'>
                  {this.props.countOfTCSQ?.number_of_explanations}
                </div>
            </Tooltip>
          )}
        </td>
      )
    } else if (this.props.pushId === 'category'){
       tdNoSubCat = (
        <td>{this.props.countLoading ? <BeatLoader color={'#bb0000'} size={6} loading={true} /> : this.props.countOfTCSQ?.number_of_subcategories}</td>
      )
       tdNoQue = (
        <td>{this.props.countLoading ? <BeatLoader color={'#bb0000'} size={6} loading={true} /> : this.props.countOfTCSQ?.number_of_questions}</td>
      )
      tdNoExpl = (
        <td>
          {this.props.countLoading ? <BeatLoader color={'#bb0000'} size={6} loading={true} /> : (
            <Tooltip
              arrow
              placement='right'
              title={
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: "center", fontSize: '14px' }}>
                  <div>{this.props.explanationMap ? `Category: ${this.props.explanationMap.total_category_explanations}` : null}</div>
                  <div>{this.props.explanationMap ? `Subcategory: ${this.props.explanationMap.total_subcategory_explanations}` : null}</div>
                </div>
              }>
                <div className='main-explanation-count'>
                  {this.props.countOfTCSQ?.number_of_explanations}
                </div>
            </Tooltip>
          )}
        </td>
      )
    } else if (this.props.pushId === 'subcategory'){
       tdNoQue = (
        <td>{this.props.countLoading ? <BeatLoader color={'#bb0000'} size={6} loading={true} /> : this.props.countOfTCSQ?.number_of_questions}</td>
      )
      tdNoExpl = (
        <td>{this.props.countLoading ? <BeatLoader color={'#bb0000'} size={6} loading={true} /> : this.props.countOfTCSQ?.number_of_explanations}</td>
      )
    }
  }
    var retVal = null;
    let className = 'action-icon-btn ';
    if (this.props.pushId === 'questions' && this.props.questionIndex === this.props.selectedRowIndex) {
      className += "question-table-row-selected "
    }

    if (this.props.type === 'quizCreation') {
      retVal = td2;
    } else {
      retVal = (
        <tr className={className}
        >
          {td1}
          {td2}
          {this.props.disable_orders?null:td3}
          {td4}
          {td5}

          {tdNoTopics}
          {tdNoCat}
          {tdNoSubCat}
          {tdNoQue}
          {tdNoExpl}

          {td6} {/* Accuracy */}
          {td7} {/* Time */}
          {td8} {/* Time */}
          <td style={styles.tbody} style={{
            display:this.props.pushId === 'subject' && this.props?.syncSwitch && "flex",
            justifyContent:this.props.pushId === 'subject' && this.props?.syncSwitch && "start"}} 
          data-title="Actions">
            {' '}
            <div style={{display:"-webkit-inline-box",minHeight:"40px"}}>
             {synButton}
             {this.props.disable_actions ? 
             <div style={{padding:"1px"}}> 

             </div>:actionButton}
            </div>
            
         </td>
          </tr>
      );
    }

    return retVal;
  }
}
